import { useRef } from "react";
import { SvgImageUpload } from "ui/svgs";
const ImageDrag = ({ onImgUrlChange }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      onImgUrlChange?.(URL.createObjectURL(file));
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleDrop = (e) => {
    e.preventDefault();

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];

      if (file.type.startsWith("image/")) {
        onImgUrlChange?.(URL.createObjectURL(file));
      }
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <div
      className={`w-full h-full border-2 border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center cursor-pointer `}
      onClick={handleClick}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="hidden"
        accept="image/*"
      />
      <SvgImageUpload />
      <div className="mt-2">
        Drag and Drop Image Here or{" "}
        <span
          style={{ fontWeight: "600", cursor: "pointer" }}
          className="underline"
        >
          Choose a File
        </span>
      </div>
    </div>
  );
};

export default ImageDrag;
